import React from 'react';
import { TimeFrame } from '@hud/portal-dtos/webapp-common.dto';
import useIssues from '../../hooks/useIssues';
import OpportunitiesCarousel from '@hud/web-components/DesignSystem/Components/DiscoveryPage/OpportunitiesCarousel/OpportunitiesCarousel';
import { FixingOpportunityProps } from '@hud/web-components/DesignSystem/Components/DiscoveryPage/Opportunity/Opportunity';
import { IconButton } from '@hud/web-components/DesignSystem/Components/IconButton';
import { PublicIssue } from '@hud/portal-dtos/issues-v2.dtos';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import PopupMenu from '@hud/web-components/DesignSystem/Components/PopupMenu/PopupMenu';
import { Menu } from '@mantine/core';

type OpportunityCarouselRendererProps = {
  timeFrame: TimeFrame;
  environmentName?: string;
  services?: number[];
};

export default function OpportunityCarouselRenderer({
  timeFrame,
  environmentName,
  services,
}: OpportunityCarouselRendererProps) {
  const issuesQuery = useIssues({
    timeFrame,
    environmentName,
    onlyFixables: true,
  });

  // todo loading state
  // const loading = issuesQuery.isLoading;
  const issues = issuesQuery.data?.issues
    .filter((issue) => {
      if (services?.length === 0) return true;
      return services?.includes(issue.serviceId);
    });


  const fixingOpportunities = issues?.map((issue) => ({
    issue,
    issueUrl: `/heads-up/issues/${issue.id}`,
    issueServiceUrl: `/explore/services/${issue.serviceId}`,
    menuElement: <OpportunityMenuRenderer issue={issue} />,
  })) as FixingOpportunityProps[];

  if (issues) {
    let moreOpportunities;
    if (issues.length > 3) {
      moreOpportunities = {
        caption: `See all ${issues.length} issues`,
        // todo filter URL by services as well
        url: `heads-up/issues?timeFrame=${timeFrame}&environmentName=${environmentName}&services=${services?.join(',')}`,
      };
    }
    return (
      <OpportunitiesCarousel
        fixingOpportunities={fixingOpportunities}
        moreOpportunities={moreOpportunities}
      />
    );
  } else return null;
}

type OpportunityMenuProps = {
  issue: PublicIssue;
};

function OpportunityMenuRenderer({ issue }: OpportunityMenuProps) {
  const ruleId = issue.ruleId;

  const targetContainer = (
    <IconButton icon="designSystem.threeDots" aria-label={'Actions'} />
  );
  const dropdownContent = (
    <Menu.Item
      component="a"
      leftSection={<HudIcon icon="designSystem.sliders" size={'20px'} />}
      href={`/heads-up/rules/${ruleId}`}
    >
      Edit Rule
    </Menu.Item>
  );

  return <PopupMenu targetContent={targetContainer} dropdownContent={dropdownContent} />;
}
